module.exports = require("multimatch");


//////////////////
// WEBPACK FOOTER
// external "multimatch"
// module id = 165
// module chunks = 0